/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import { epochToMomentTimeZone } from "openstack-uicore-foundation/lib/utils/methods";
import { DATE_FORMAT, DEFAULT_PER_PAGE } from "../utils/constants";
import { RECEIVE_SHOWS, REQUEST_SHOWS } from "../actions/show-actions";

const DEFAULT_STATE = {
  shows: [],
  filters: { hide_past_events: false },
  order: "summit_name",
  orderDir: 1,
  currentPage: 1,
  lastPage: 1,
  perPage: DEFAULT_PER_PAGE,
  total: 0
};

const showListReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case REQUEST_SHOWS: {
      const { order, orderDir, filters } = payload;
      return { ...state, order, orderDir, filters };
    }
    case RECEIVE_SHOWS: {
      const {
        data,
        total,
        last_page: lastPage,
        per_page: perPage,
        current_page: currentPage
      } = payload.response;

      const shows = data.map((it) => ({
        id: it.id,
        summit_name: it.summit?.name,
        summit_id: it.summit?.id,
        sponsor_id: it.sponsor?.id,
        sponsor: it.sponsor.company_name,
        start_date:
          epochToMomentTimeZone(
            it.summit.start_date,
            it.summit.time_zone_id
          )?.format(DATE_FORMAT) || "",
        end_date:
          epochToMomentTimeZone(
            it.summit.end_date,
            it.summit.time_zone_id
          )?.format(DATE_FORMAT) || "",
        sponsorships: it.sponsor?.sponsorships
      }));

      return {
        ...state,
        shows,
        total,
        lastPage,
        perPage,
        currentPage
      };
    }
    default:
      return state;
  }
};

export default showListReducer;
